var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAgents = function SvgAgents(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2a1 1 0 0 1 1 1v1.6h3.2A2.8 2.8 0 0 1 18 7.4v6.8a2.8 2.8 0 0 1-2.8 2.8H6.8A2.8 2.8 0 0 1 4 14.2V7.4a2.8 2.8 0 0 1 2.8-2.8H10V3a1 1 0 0 1 1-1ZM16 5.8H6a.8.8 0 0 0-.8.8v8.4a.8.8 0 0 0 .8.8h10a.8.8 0 0 0 .8-.8V6.6a.8.8 0 0 0-.8-.8ZM8.6 9.2a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2Zm4.8 0a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2ZM2.3 9.1a.9.9 0 0 1 .9.9v2.6a.9.9 0 1 1-1.8 0V10a.9.9 0 0 1 .9-.9Zm17.4 0a.9.9 0 0 1 .9.9v2.6a.9.9 0 1 1-1.8 0V10a.9.9 0 0 1 .9-.9ZM8.4 18.2h5.2a.8.8 0 0 1 0 1.6H8.4a.8.8 0 0 1 0-1.6Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAgents, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/agents.9ec778c4.svg";
export { ForwardRef as ReactComponent };